export const externalLinks = {
    cancellationPolicies: 'https://www.ifiesta.com.mx/documents/cancellation_policies',
    paymentPolicies: 'https://www.ifiesta.com.mx/documents/payment_policies',
}